import AWS from "aws-sdk";
/*****************************
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  Credentials,
  AuthenticationDetails
} from "amazon-cognito-identity-js";
******************************/
import React from 'react';
import {Link} from 'react-router-dom'
// *** import { userIdFunc, handleErrorFunc } from '../App';
import { handleErrorFunc } from '../App';

import { Map, Marker, Popup, TileLayer } from 'react-leaflet';

import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
// *** import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
// *** import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import {grey400} from 'material-ui/styles/colors';

import {
  Table,
  TableBody,
// ***  TableHeader,
// ***  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import appConfig from '../appConfig';
// *** import {bucketname,tablename,commenttable,toLocaleString,makeCommentKey,noimage,noimageurl,nothumbnailurl,escape_html,cachepath}  from '../appConfig';
import {bucketname,tablename,commenttable,toLocaleString,makeCommentKey,noimage,nothumbnailurl,escape_html,cachepath}  from '../appConfig';

const kukiPos = [36.0619954, 139.6668380]; //久喜市  緯度36.0619954 経度139.6668380

/*************************************************
■ロジックを複雑にしている3変数
①this.state.updateItem == null =>新規投稿 , this.state.updateItem != null =>編集投稿
②postDeleteAndAdd(item,addCallback) addCallback == null  ==> 削除 , addCallback != null  ==> 編集
③imageOverwrite: false, //画像の上書きアップロード。編集時は古いものを削除する
*************************************************/

//===============================
// class Admin
//===============================
export default class Admin extends  React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      IdentityPoolId: "",
      identityId: "",
      imgurl: "",
      items : [],
      email: "",
      username: "",
//----------------------------投稿フォーム関連
      title: "",
      story: "",
      imageOverwrite: false, //画像の上書きアップロード。編集時は古いものを削除する
      mapUse: false,
      position: kukiPos,
      file: "",
      updateItem: null // nin-null if and only if update
//----------------------------
    };
    this.handlePostDelete = this.handlePostDelete.bind(this);
    this.postAdd = this.postAdd.bind(this);
    this.postDeleteAndAdd = this.postDeleteAndAdd.bind(this);
  }




//===============================
// handlePostNew()
//===============================
  handlePostNew() {
      this.setState( {title: ""} );
      this.setState( {story: ""} );
      this.setState( {imageOverwrite: false} );
      this.setState( {mapUse: false} );
      this.setState( {position: kukiPos} );
      this.setState( {file: ""} );
      this.setState( {updateItem: null} );
  }




//===============================
// handlePostEdit()
//===============================
  handlePostEdit(item) {
      this.setState( {title: item.title} );
      this.setState( {story: item.story} );
      this.setState( {imageOverwrite: false} ); //編集の時は既存の画像を使うのがデフォルト
      this.setState( {mapUse: item.mapUse} );
      this.setState( {position: item.position} );
      this.setState({file: ""});
      this.setState( {updateItem: item} );
      window.scrollTo(0, 0);
  }

//===============================
// _fetch()
//===============================
  _fetch(identityId) {
    const _self = this;
    //const identityId = this.state.identityId

//-------------------------------
// S3 scan
//-------------------------------
//http://tech.sanwasystem.com/entry/2016/01/20/143533

    var dynamo = new AWS.DynamoDB.DocumentClient();

    var param = {
      TableName : tablename,
      ScanIndexForward: false, //queryには効くが、scanには効かない
      KeyConditionExpression : "identityId = :identityId",
      ExpressionAttributeValues : {":identityId" : identityId}
    };
    dynamo.query(param, function(err, data) {
        if (err) {
            console.log("### Error="+err);
        } else {
            //console.log("### data="+JSON.stringify(data.Items));
            _self.setState({items: data.Items});
        }
    });
  }


//===============================
// componentWillMount()
//===============================
  componentWillMount() {

// ***    const _self = this;
    const email = localStorage.getItem('email');
    const username = localStorage.getItem('username');
    var identityId = AWS.config.credentials.identityId;

    if( !email ) {
        handleErrorFunc('エラー：ログインしていません');
        return;
    }

    console.log("##### AWS.config.credentials.identityId="+identityId)
    this.setState({identityId: identityId});
    this.setState({email: email});
    this.setState({username: username});

    this._fetch(identityId);

  }


//===============================
// handleFileChange()
//===============================
  handleFileChange(e) {
    this.setState({file: e.target.files[0]});
  }
//===============================
// handleTitleChange()
//===============================
  handleTitleChange(e) {
    this.setState({title: e.target.value});
  }
//===============================
// handleStoryChange()
//===============================
  handleStoryChange(e) {
    this.setState({story: e.target.value});
  }
//===============================
// handleImageToggle()
//===============================
   handleImageToggle(e, isInputChecked) {
    //this.setState({story: e.target.value});
    this.setState({imageOverwrite: isInputChecked});
  }
//===============================
// handleMapToggle()
//===============================
  handleMapToggle(e, isInputChecked) {
    //this.setState({story: e.target.value});
    this.setState({mapUse: isInputChecked});
  }

//===============================
// handleMapClick()
//===============================
  handleMapClick( e ) {
      console.log("### map click event="+JSON.stringify(e.latlng));
      this.setState( {position: [e.latlng.lat, e.latlng.lng]} );
  }


//===============================
// ■handlePostDelete()
//===============================
  handlePostDelete(item) {
    if( ! window.confirm(item.title+" を削除しようとしています。\n画像や他のユーザのコメントも削除されてしまいます。\n本当に削除しますか？") ) {
        return;
    }
    this.postDeleteAndAdd(item, null);

    //--- clear cache
    const s3 = new AWS.S3();
    const params = {
        Bucket: bucketname,
        Key: cachepath,
    };
    s3.deleteObject(params, function(err, data) {
      if (err) console.log("### delete cach failed"); // an error occurred
      else     console.log("### delete cach ok");           // successful response
    });
  }



//===============================
// ●postDeleteAndAdd()
// addCallback == null  ==> 削除
// addCallback != null  ==> 編集
//===============================
  postDeleteAndAdd(item, addCallback) {

    if( !addCallback || this.state.imageOverwrite) { // == 削除または上書きなら、画像を消す
        // ★Delete Image
        const s3 = new AWS.S3();
        const params1 = {
            Bucket: bucketname,
            Key: item.filename,
        };
        s3.deleteObject(params1, function(err, data) {
          if (err) console.log(err); // an error occurred
          else     console.log("### delete image ok");           // successful response
        });
        // ★Delete Thumbnail
        const params2 = {
            Bucket: bucketname,
            Key: item.thumbnail,
        };
        s3.deleteObject(params2, function(err, data) {
          if (err) console.log(err); // an error occurred
          else     console.log("### delete thubnail ok");           // successful response
        });
    }


    // ★Delete Post
    // For a composite primary key, you must provide values for both the partition key and the sort key.
    let dynamo = new AWS.DynamoDB.DocumentClient();
    const params3 = {
        TableName: tablename,
        Key: {
           identityId: item.identityId, // ★partition key
           uploadTime: item.uploadTime  // ★sort key
        }
    };
    dynamo.delete(params3, function (err, res) {
      if (err) {
          console.log("### delete table err:"+err); // an error occurred
      } else{
          console.log("### delete table ok"); // successful response
          if(addCallback) { //編集 => 削除 then 追加
              addCallback();
          }
      }
    });



    // ★Delete Comments
    if(addCallback) { //編集ならコメントは削除しない
        return;
    }

    let commentKey = makeCommentKey(item.identityId, item.uploadTime);
    console.log("### commentKey="+commentKey);

    const param = {
      TableName : commenttable,
      KeyConditionExpression : "commentKey = :commentKey",
      ExpressionAttributeValues : {":commentKey" : commentKey}
    };
    
    dynamo.query(param, function(err, data) {
        if (err) {
            console.log("### Error="+err);
        } else {
            //console.log("### data="+JSON.stringify(data.Items));
            data.Items.forEach(function(element, index, array) {
                var params = {
                    TableName: commenttable,
                    Key: {
                       commentKey: commentKey, // ★partition key
                       commentTime: element.commentTime  // ★sort key
                    }
                };
                dynamo.delete(params, function (err, res) {
                  if (err)  console.log("### delete comment table err:"+err); // an error occurred
                  else     console.log("### delete comment table ok"); // successful response
                });
            });
        }
    });

    // ★Re-render
    this._fetch(this.state.identityId);
  }


//===============================
// ■handleSubmit()
// this.state.updateItem == null =>新規投稿
// this.state.updateItem != null =>編集投稿
//===============================
  handleSubmit(e) {
    e.preventDefault();

    if(this.state.title === "" || this.state.story === "") {
        handleErrorFunc('エラー：タイトルまたは投稿内容が空白です' );
        return;
    }

    if( !this.state.updateItem ) { //新規投稿
        this.postAdd();        
    } else {                        //編集投稿
        this.postDeleteAndAdd(this.state.updateItem, this.postAdd);  //★updateは削除して追加。追加して削除してはいけない。
    }

    //--- clear cache
    const s3 = new AWS.S3();
    const params = {
        Bucket: bucketname,
        Key: cachepath,
    };
    s3.deleteObject(params, function(err, data) {
      if (err) console.log("### delete cach failed"); // an error occurred
      else     console.log("### delete cach ok");           // successful response
    });
  }



//===============================
// ●postAdd()
// this.state.updateItem == null =>新規投稿
// this.state.updateItem != null =>編集投稿
//===============================
  postAdd() {
    const _self = this;
    const identityId = _self.state.identityId;

//-------------------------------
// Date
//-------------------------------
    let uploadTime = 0;
    let uploadDate = "";
    let partitionYear = 0;
    if( !this.state.updateItem ) { //新規投稿
        const date = new Date() ;
        uploadTime = date.getTime();
        uploadDate = toLocaleString(date);
        partitionYear = date.getFullYear();
    } else {                        //編集投稿
        uploadTime = _self.state.updateItem.uploadTime;
        uploadDate = _self.state.updateItem.uploadDate;
        partitionYear = _self.state.updateItem.partitionYear;
    }


//-------------------------------
// S3 put
//-------------------------------
    let filepath = noimage;
    let thumbnail = noimage;
    let fileType = noimage;
    if( _self.state.imageOverwrite && !!_self.state.file) { 
// ***        if (!_self.state.file.name.match(/^[0-9a-zA-Z\.\_\-]*$/)) {
        if (!_self.state.file.name.match(/^[0-9a-zA-Z._-]*$/)) {
            handleErrorFunc('エラー：ファイル名は小文字の英数字と . - _ しか使えません: '+_self.state.file.name );
            return;
        }
        filepath = 'contents/images/'+identityId+'/'+_self.state.file.name;
        thumbnail = filepath.replace(/images/, 'thumbnail');
        fileType = _self.state.file.type;
        console.log("filepath="+filepath);
        var params = {
            Bucket: bucketname,
            Key: filepath,
            ContentType: _self.state.file.type,
            Body: _self.state.file,
            Metadata: {
              data: JSON.stringify({
                identityId: identityId,
                uploadTime: uploadTime,
                uploadDate: uploadDate
              })
            }
        };
        var s3 = new AWS.S3();
        s3.putObject(params, function(err, data) {
            if(err) {
                console.log("Err: upload failed :" +err);
            } else {
                console.log("Success: upload ok");
                let url = 'http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/'+filepath;
                console.log("######11 imgurl="+url);
                _self.setState({imgurl: url});
            }
        });
    } else if ( _self.state.updateItem && !_self.state.imageOverwrite ) { //編集投稿で上書きアップロード無し
        filepath = _self.state.updateItem.filename;
        thumbnail = _self.state.updateItem.thumbnail;
        fileType = _self.state.updateItem.fileType;;    
    }
//-------------------------------
// DynamoDB putItem
//-------------------------------
    const title = escape_html(_self.state.title);
    let story = escape_html(_self.state.story);
    story = story.replace(/((http:|https:)\/\/[\x21-\x26\x28-\x7e]+)/gi, "<a href='$1'>$1</a>");


    var docClient = new AWS.DynamoDB.DocumentClient();
// ***    var params = {
     params = {
        TableName: tablename,
        Item:{
             identityId: identityId, // ★prime partition key
             email: _self.state.email,
             username: _self.state.username,
             filename: filepath,
             thumbnail: thumbnail,
             type: fileType,
             title: title,
             story: story,
             imageOverwrite: _self.state.imageOverwrite,
             mapUse: _self.state.mapUse,
             position: _self.state.position,
             uploadTime: uploadTime, // ★prime & secondary sort key
             uploadDate: uploadDate,
             partitionYear: partitionYear, //★secondary partition key
             refCounter: 0
        }
    };
    docClient.put(params, function(err, data) {
        if(err) {
            console.log("Err: table put :" +err);
        } else {
            console.log("Success: table put ok");
        }
    });

//-------------------------------
// Clear form
//-------------------------------
    this.handlePostNew();

    this._fetch(identityId);

  }



//===============================
// render
//===============================
  render(){
    const styles = {
      paper: {
        width: '80%',
        margin: 30,
        padding: 30,
        display: 'inline-block',
      },
      toggle: {
        marginBottom: 16,
      },
      gridList: {
        width: 500,
        height: 450,
        overflowY: 'auto',
      },
      raised: {
        margin: 12,
      }
    };

    let list=[];
//----------------------------
    this.state.items.map((item,idx) => {
        let imgurl = nothumbnailurl;
        if(item.thumbnail!==noimage) {
            imgurl = 'http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/'+item.thumbnail;
        }
        list.push (
            <TableRow key={idx} valign={'top'}>
              <TableRowColumn width={200}>
                  <Link to={{ pathname:'/post', state:item }}>
                      <img alt="img" src={imgurl} />
                  </Link>
              </TableRowColumn>
              <TableRowColumn align={'left'} style={{whiteSpace: "normal",wordWrap: "break-word"}}>
                  <h3>{item.title}</h3>
                  <div>{item.username} / {item.uploadDate}</div>
                  <br />
                  <div style={{fontSize:14}}>{item.story}</div>
                  <div>
                    <FlatButton label="編集" secondary={true} onClick={()=>this.handlePostEdit(item)} />
                    <FlatButton label="削除" secondary={true} onClick={()=>this.handlePostDelete(item)} />
                  </div>
              </TableRowColumn>
            </TableRow>
        )
        return item  // *** for compile error
    })


//----------------------------
    let map = null;
    if(this.state.mapUse) {
        let position = this.state.position;
        map = (
          <Map center={position} zoom={13} onClick={this.handleMapClick.bind(this)}>
            <TileLayer
              url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={position}>
              <Popup>
                <span>A pretty CSS3 popup.<br/>Easily customizable.</span>
              </Popup>
            </Marker>
          </Map>
        );
    }
//----------------------------
    let formTitle="";
    let mess = "";
    let newPost = null;
    if( !! this.state.updateItem ) {
        formTitle = '「'+this.state.updateItem.title+'」の編集';
        newPost = (<FlatButton label="新規投稿" secondary={true} onClick={()=>this.handlePostNew()} />);
        if(this.state.imageOverwrite) {
            if( this.state.updateItem.filename === noimage ) {
                mess = '画像がアップロードされていません。画像をアップロードする時はファイルを選択してください。';
            } else {
                mess = '前に画像がアップロードされています。新画像を選択して投稿すると画像は置換されます。新画像を選択しないで投稿すると画像は削除されます。';
            }
        } else {
            if( this.state.updateItem.filename === noimage ) {
                mess = '画像がアップロードされていません。画像をアップロードする時はONにしてファイルを選択してください。';
            } else {
                mess = '前に画像がアップロードされています。このまま投稿すると前の画像が自動的に使用されます。';
            }
        }
    } else {
        formTitle = '新規投稿';
        if(this.state.imageOverwrite) {
            mess = '画像ファイルを選択して投稿すると画像がアップロードされます。ちなみに編集で画像の交換が可能です';
        } else {
            mess = '画像ファイルアップロードする時は、ここをONにするとファイル選択ボタンが表示されます。';
        }
    }
//----------------------------
    let fileupload = null;
    if(this.state.imageOverwrite) {
        fileupload = (<div><input type="file" onChange={this.handleFileChange.bind(this)}/><br /><br /></div>);
    }
//----------------------------

    return (
      <div>
        <Paper style={styles.paper} zDepth={1}>
          <h2 style={{textAlign: 'left'}}>{formTitle}</h2>

          <form onSubmit={this.handleSubmit.bind(this)}>
            {fileupload}
            <TextField fullWidth={true}
                 value={this.state.title}
                 hintText="タイトル"
                 onChange={this.handleTitleChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.story}
                 hintText="投稿内容（改行で複数行入力が可能です）"
                 multiLine={true}
                 onChange={this.handleStoryChange.bind(this)}/><br />
            <input type="submit" />
          </form>
          <br /><br /><br />
          <div>
            <Toggle label="画像をアップロードする" style={styles.toggle} toggled={this.state.imageOverwrite} onToggle={this.handleImageToggle.bind(this)}/>
            <p style={{fontSize: 12, color: grey400 , marginTop:0, textAlign: 'left'}}>{mess}</p>
            <Toggle label="久喜マップで位置を指定する" style={styles.toggle} toggled={this.state.mapUse} onToggle={this.handleMapToggle.bind(this)}/>
            <p style={{fontSize: 12, color: grey400 , marginTop:0, textAlign: 'left'}}>マップ情報もあわせて投稿したい場合は、ここをONにするとマップが表示されますので、投稿に関連した位置をクリックして投稿してください。</p>
            <br />
            {newPost}
          </div>
        </Paper>
        <img alt="img" src={this.state.imgurl}/>
        <br />
        {map}
        <br />
        <div style={{width:'80%', marginLeft: 'auto', marginRight: 'auto'  }}>
            <h3>{this.state.email} さんの過去の投稿</h3>
            <Table selectable={false} style={{ tableLayout: 'auto'}}>
                <TableBody displayRowCheckbox={false}>
                   {list}
                </TableBody>
            </Table>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/views/Admin.js